import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import img1 from './images/kits/k1.jpeg';
import img2 from './images/kits/k2.jpeg';
import img3 from './images/kits/k3.jpeg';
import kit2 from './images/kits/kit2.jpg';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { Product } from './types';
function About()
{
    return (    
    <div className="min-h-screen">
      <Header />      
      <main>        
        {/* Intro Section */}
        <section className="py-24 bg-black">
          <div className='container mt-7'>
                <div className='text-center'>
                    <h1>Arvind Mera Sathi</h1>
                    Arvind mera sathi is in india top leading online and social media personal care platform for male and female.<br/>
                    We have above youtube 346k followers and instagram 87k followers across the globe who trust our brands arvind mera sathi regularly.<br/>
                    We basically work on personal health care issues on ayurveda basis and from our personal and work experience.<br/>
                    We started this in 2014 with the initiative to help.                 
                </div>
            </div>
        </section>        
      </main>
      <Footer />
    </div>
  );  
}

export default About;
